import React from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import StitchSymbol from './StitchSymbol';

const StitchPalette = ({
  STITCH_TYPES,
  STITCH_CATEGORIES,
  activeCategory,
  setActiveCategory,
  selectedStitch,
  setSelectedStitch,
  cellSize
}) => (
  <Box sx={{ width: '100%', mb: 2 }}>
    <Typography variant="h6" gutterBottom>Stitch Palette</Typography>
    {/* Category Tabs */}
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Tabs
          value={activeCategory}
          onChange={(e, newValue) => setActiveCategory(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ flex: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          {Object.keys(STITCH_CATEGORIES).map((category) => (
            <Tab key={category} label={category} value={category} />
          ))}
        </Tabs>
      </Box>
    </Box>
    {/* Stitch Grid */}
    <Box sx={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: 0.5,
      mb: 2,
    }}>
      {Object.entries(STITCH_TYPES)
        .filter(([stitchKey]) => STITCH_CATEGORIES[activeCategory]?.includes(stitchKey))
        .map(([stitchKey]) => {
          const currentStitch = STITCH_TYPES[stitchKey];
          const isSelected = selectedStitch === stitchKey;
          if (currentStitch.hidden) return null; // Skip hidden stitches

          return (
            <Box
              key={stitchKey}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                cursor: 'pointer',
                opacity: currentStitch.disabled ? 0.5 : 1,
                pointerEvents: currentStitch.disabled ? 'none' : 'auto',
                border: '2px solid', // Always 2px to prevent UI jump
                borderColor: isSelected ? '#1976d2' : '#bbb',
                borderRadius: 2,
                backgroundColor: isSelected ? 'rgba(25, 118, 210, 0.08)' : '#fff',
                transition: 'all 0.15s',
                m: 0.5,
                p: 0.5,
                minWidth: 48,
                minHeight: 48,
                '&:hover': {
                  borderColor: '#1976d2',
                  backgroundColor: 'rgba(25, 118, 210, 0.04)',
                },
              }}
              onClick={() => setSelectedStitch(isSelected ? 'k' : stitchKey)}
              title={currentStitch.label || stitchKey}
            >
              <StitchSymbol 
                type={stitchKey}
                isRS={true}
                cellSize={cellSize * 1.2}
                style={{ marginBottom: 4 }}
              />
              <Typography variant="caption" align="center" sx={{ fontWeight: isSelected ? 'bold' : 'normal' }}>
                {currentStitch.label || stitchKey}
              </Typography>
            </Box>
          );
        })}
    </Box>
  </Box>
);

export default StitchPalette;
